import React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import VerifiedOutlinedIcon from '@mui/icons-material/VerifiedOutlined';
import AutorenewOutlinedIcon from '@mui/icons-material/AutorenewOutlined';
import SupportAgentOutlinedIcon from '@mui/icons-material/SupportAgentOutlined';

const features = [
  {
    icon: LocalShippingOutlinedIcon,
    title: 'Free Shipping',
    description: 'Free delivery on all orders above ₹1,999',
  },
  {
    icon: VerifiedOutlinedIcon,
    title: '100-Night Trial',
    description: 'Sleep on it for 100 nights, risk-free',
  },
  {
    icon: AutorenewOutlinedIcon,
    title: 'Easy Returns',
    description: 'No questions asked return policy',
  },
  {
    icon: SupportAgentOutlinedIcon,
    title: '24/7 Support',
    description: 'Sleep experts ready to help anytime',
  },
];

function Features() {
  return (
    <Box sx={{ py: 6, bgcolor: '#f8f9fa' }}>
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          {features.map((feature) => (
            <Grid item xs={6} md={3} key={feature.title}>
              <Box
                sx={{
                  textAlign: 'center',
                  px: 2,
                }}
              >
                <feature.icon
                  sx={{
                    fontSize: 48,
                    color: 'primary.main',
                    mb: 2,
                  }}
                />
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 600,
                    mb: 1,
                    fontSize: { xs: '1rem', md: '1.1rem' },
                  }}
                >
                  {feature.title}
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ fontSize: { xs: '0.8rem', md: '0.875rem' } }}
                >
                  {feature.description}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}

export default Features;
